import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

// One styled tooltip for the racing page, in place of the browser's own
// `title` tooltips. Give any element data-tip="..." and it shows on hover
// after a short delay, above the element (below it near the top of the
// screen). The innermost data-tip wins. Mounted once, by the desktop page.

const DELAY_MS = 350
const EDGE = 140   // keep the tip's centre this far from the window's sides

export default function HoverTip() {
  const [tip, setTip] = useState(null)   // { text, x, y, below }

  useEffect(() => {
    let timer = null
    let current = null
    const hide = () => {
      current = null
      clearTimeout(timer)
      setTip(null)
    }
    const show = (el) => {
      const text = el.getAttribute('data-tip')
      if (!text || !el.isConnected) return
      const r = el.getBoundingClientRect()
      const below = r.top < 70
      setTip({
        text,
        below,
        x: Math.max(EDGE, Math.min(window.innerWidth - EDGE, r.left + r.width / 2)),
        y: below ? r.bottom + 8 : r.top - 8,
      })
    }
    const over = (e) => {
      const el = e.target.closest?.('[data-tip]') || null
      if (el === current) return
      hide()
      current = el
      if (el) timer = setTimeout(() => show(el), DELAY_MS)
    }
    document.addEventListener('mouseover', over)
    document.addEventListener('mousedown', hide)
    document.addEventListener('scroll', hide, true)
    window.addEventListener('blur', hide)
    return () => {
      clearTimeout(timer)
      document.removeEventListener('mouseover', over)
      document.removeEventListener('mousedown', hide)
      document.removeEventListener('scroll', hide, true)
      window.removeEventListener('blur', hide)
    }
  }, [])

  if (!tip) return null
  return createPortal(
    <div className={`rc-portal rc-hovertip${tip.below ? ' is-below' : ''}`} style={{ left: tip.x, top: tip.y }} role="tooltip">
      {tip.text}
    </div>,
    document.body,
  )
}
